<template>
  <div>
    <v-layout wrap justify-space-between>
      <v-flex xs12>
        <div class="mb-2 mt-4">
          <div class="mb-1" v-if="isOcrResultsLoaded">{{ $t('a') }}</div>
        </div>
        <div class="text-end">
          <v-tooltip top class="buttonOfTooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-btn style="position: absolute; right: 27px; margin-top: 14px" text class="primary--text" @click="resetAllIndents" x-small elevation="0" v-bind="attrs" v-on="on">
                <v-icon class="img-horizontal-flip">mdi-playlist-remove</v-icon>
              </v-btn>
            </template>
            <small>{{ $t('resetAllIndents') }}</small>
          </v-tooltip>
        </div>
        <vue-editor ref="editor" v-model="descriptionModel" :editorToolbar="editorToolbar" :editorOptions="editorOptions"></vue-editor>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  props: {
    profile: Object,
    isOcrResultsLoaded: Boolean,
  },
  data: () => ({
    editorToolbar: [[{ list: "bullet" }]],
    editorOptions: {
      formats: ['list', 'indent'],
      modules: { keyboard: { bindings: { 'tab': { key: 9, handler: function() { return false; } } } } }
    },
    descriptionModel: ''
  }),
  mounted() {
    this.descriptionModel = JSON.parse(JSON.stringify(this.profile.skills.technicalSkillsDescription))
  },
  methods: {
    resetAllIndents() {
      this.descriptionModel = this.descriptionModel
        // Convert all paragraphs to indent lvl 0
        .replace(/<p>/g, '<ul><li class="ql-indent-0">')
        .replace(/<\/p>/g, '</li></ul>')
        .replace(/<ul><\/ul>/g, '')
        // Convert all bulletpoints to indent lvl 0
        .replace(/(<li class="ql-indent-)\d(">)/g, '<li class="ql-indent-0">')
        // Convert all empty bulletpoint to empty paragraph
        .replace(/<li class="ql-indent-0"><br><\/li>/g, '</ul><p><br></p><ul>')
        .replace(/<ul><\/ul>/g, '')
    }
  },
  watch: {
    descriptionModel: {
      handler() {
        // Prevent paragraphs indentation: remove ql-indent classes from paragraphs
        let newDescription = this.descriptionModel.replace(/(<p class="ql-indent-)\d(">)/g, function() {
          return '<p>';
        })

        // Replace <li> by <li class="ql-indent-0">
        if (newDescription.includes('<li>')) {
          newDescription = newDescription.replace(/<li>/g, '<li class="ql-indent-0">')
        }

        if (newDescription !== this.profile.skills.technicalSkillsDescription) {
          // Update v-model
          this.profile.skills.technicalSkillsDescription = newDescription
        }
      }
    }
  }
}
</script>

<i18n>
{
  "fr": {
    "a": "Sélectionnez le texte des compétences techniques dans le CV original.",
    "resetAllIndents": "Réaligner toutes les indentations en bulletpoints de niveau 1"
  },
  "en": {
    "a": "Select the text about technical skills from the original CV.",
    "resetAllIndents": "Re-align all the indents into level 1 bulletpoints"
  }
}
</i18n>